import React from 'react';
import About from '../components/About';

const AboutPage: React.FC = () => {
  return <About />;
};

export default AboutPage;
